export function buildTaskMappingOptions(bundle) {
  const options = [];
  if (!bundle?.tasks?.length) return options;
  for (const task of bundle.tasks) {
    options.push({
      value: `task:${task._id}`,
      label: `${task.title || "—"}`,
    });
    for (const sub of task.subtasks || []) {
      options.push({
        value: `subtask:${task._id}:${sub._id}`,
        label: `→ ${sub.title || "—"}`,
      });
    }
  }
  return options;
}

export function getTaskLabel(taskOverride, bundle) {
  if (!taskOverride) return "—";
  const options = buildTaskMappingOptions(bundle);
  const opt = options.find((o) => o.value === taskOverride);
  return opt?.label ?? taskOverride;
}

/** Two-line display parts for GroupedTaskPicker trigger and assigned rows. */
export function getTaskDisplayParts(taskOverride, bundle) {
  if (!taskOverride || !bundle?.tasks?.length) {
    return { parent: null, child: null, isSubtask: false, fullLabel: null };
  }
  const subMatch = String(taskOverride).match(/^subtask:([^:]+):(.+)$/);
  if (subMatch) {
    const taskId = subMatch[1];
    const subId = subMatch[2];
    const task = bundle.tasks.find((t) => String(t._id) === taskId);
    const sub = task?.subtasks?.find((s) => String(s._id) === subId);
    const parent = task?.title || "—";
    const child = sub?.title || "—";
    return { parent, child, isSubtask: true, fullLabel: `${parent} / ${child}` };
  }
  const taskMatch = String(taskOverride).match(/^task:(.+)$/);
  if (taskMatch) {
    const task = bundle.tasks.find((t) => String(t._id) === taskMatch[1]);
    const title = task?.title || "—";
    return { parent: title, child: null, isSubtask: false, fullLabel: title };
  }
  return { parent: taskOverride, child: null, isSubtask: false, fullLabel: taskOverride };
}

export function buildGroupedTaskList(bundle) {
  if (!bundle?.tasks?.length) return [];
  return bundle.tasks.map((task) => ({
    taskId: String(task._id),
    title: task.title || "—",
    subtasks: (task.subtasks || []).map((sub) => ({
      subtaskId: String(sub._id),
      title: sub.title || "—",
      value: `subtask:${task._id}:${sub._id}`,
    })),
    value: `task:${task._id}`,
  }));
}

export function formatExpectedCostKr(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return "—";
  return `${Math.round(n).toLocaleString("sv-SE")} kr`;
}

export const emptyExpectedCostForm = {
  taskOverride: "",
  amount: "",
  description: "",
  supplierName: "",
  notes: "",
};
